import { List } from 'immutable';
export const INITIALIZE_PARKING_PASSES = 'initialize-parking-passes';
const initializeParkingPasses = ({ selectedParkingPassIds }) => ({
  type: INITIALIZE_PARKING_PASSES,
  payload: { selectedParkingPassIds: List(selectedParkingPassIds) },
});
export default initializeParkingPasses;
